import { enumUnitVal, kDPIScreen, kStdHeaderHeight } from "../constants";

export function GetStdHeaderHeight(units) {
  if (units == enumUnitVal.inches) return kStdHeaderHeight;
  else {
    if (units == enumUnitVal.cm) return kStdHeaderHeight * 2.54;
    else return Math.round(kStdHeaderHeight * kDPIScreen);
  }
}
